import React from "react";

import { Typography } from "@packages/ds";
import { FormattedMessage, useIntl } from "react-intl";

import { useNotification } from "Containers/Notifications";
import { Button, ButtonWrapper } from "ds/Button";
import Modal from "ds/Modal";
import { useDeleteTeamProjectAccess } from "src/organization/pages/settings/pages/teams/hooks/useDeleteTeamProjectAccess";

import type { Team } from "Api/teams/teams.types";

type Props = {
  team: Team;
  projectId: string;
  projectName?: string;
  onClose: () => void;
};

export const RemoveTeamFromProjectModal = (props: Props) => {
  const { formatMessage } = useIntl();
  const notify = useNotification();
  const [deleteTeamProjectAccess, isDeleting] = useDeleteTeamProjectAccess(
    props.team.organization_id
  );

  const onRemove = async () => {
    await deleteTeamProjectAccess(props.team.id, props.projectId);
    notify.success(
      formatMessage({ id: "access.team.delete.modal.notification.title" }),
      formatMessage<React.ReactNode>(
        { id: "access.team.delete.modal.notification.description" },
        {
          teamname: props.team.label,
          projectname: props.projectName,
          b: chunks => <b>{chunks}</b>
        }
      )
    );
    props.onClose();
  };

  return (
    <Modal isOpen onOpenChange={props.onClose} handleClose={props.onClose}>
      <Typography.Title tag="h3">
        <FormattedMessage id="remove_team" />
      </Typography.Title>
      <Typography.BodyText>
        <FormattedMessage
          id="access.team.delete.modal.description"
          values={{
            teamname: props.team.label,
            projectname: props.projectName,
            b: (...chunks) => <b>{chunks}</b>
          }}
        />
      </Typography.BodyText>
      <ButtonWrapper spacing="modal" justifyContent="end">
        <Button variant="secondary" analyticId="cancel" onClick={props.onClose}>
          <FormattedMessage id="cancel" />
        </Button>
        <Button disabled={isDeleting} analyticId="yes" onClick={onRemove}>
          <FormattedMessage id="yes" />
        </Button>
      </ButtonWrapper>
    </Modal>
  );
};
